import React from 'react';
import { Box } from '@mui/material';
import ZoomIcon from '@stack/assets/icons/zoomIcon.svg';

export type ZoonIconWrapperProps = React.PropsWithChildren<{
  onZoon: () => void;
}>;

/**
 * ===========================
 * MAIN
 * ===========================
 */
const ZoonIconWrapper: React.FC<ZoonIconWrapperProps> = (props) => {
  // ======================= HOOKS

  const { onZoon, children } = props;

  // ======================= STATE

  // ======================= API

  // ======================= EVENTS

  // ======================= VARIABLES

  // ======================= RENDER FUNCTIONS

  // ======================= VIEWS
  return (
    <Box>
      <Box
        sx={{
          position: 'absolute',
          right: 10,
          top: 10,
          '&:hover': {
            filter: 'brightness(0.8)',
          },
          width: 34,
          height: 34,
          cursor: 'pointer',
        }}
        onClick={onZoon}
      >
        <ZoomIcon />
      </Box>
      {children}
    </Box>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default ZoonIconWrapper;
